import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class DocumentosService {
	private data = null;
	private url = environment.serviceApi;
	constructor(public http: Http) { }

	getDocumentos(ordem = null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/documento' + (ordem ? '/ordem/' + ordem : ''))
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getDocumento(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/documento/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getDocumentoArquivo(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/documento/getArquivo/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	criaDocumento(data) {

		console.log("[criaDocumento]");
		console.log("[data] = " , data);

		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/documento', {
				documento_nome: data.documento_nome,
				documento_descricao: data.documento_descricao,
				documento_data: data.documento_data,
				documento_arquivo: data.documento_arquivo,
				documento_arquivo_nome: data.documento_arquivo_nome,
				documento_status: data.documento_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	editaDocumento(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/documento/' + data.documento_id, {
				documento_nome: data.documento_nome,
				documento_descricao: data.documento_descricao,
				documento_data: data.documento_data,
				documento_arquivo: data.documento_arquivo,
				documento_arquivo_nome: data.documento_arquivo_nome,
				documento_status: data.documento_status
			})
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	apagaDocumento(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/documento/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}
}
